export default "__VITE_ASSET__VUD5ugaH__"